import React from 'react';
import { withMediaClientAndSettings, withMediaClient } from '@atlaskit/media-client-react';
import MediaCardAnalyticsErrorBoundary from './media-card-analytics-error-boundary';
import { Card as InternalCard } from './card';
import { fg } from '@atlaskit/platform-feature-flags';
export var CardWithMediaClient = function CardWithMediaClient(props) {
  var dimensions = props.dimensions,
    onClick = props.onClick;
  var Card = React.useMemo(function () {
    if (fg('platform_media_video_captions')) {
      return withMediaClientAndSettings(InternalCard);
    }
    return withMediaClient(InternalCard);
  }, []);
  return /*#__PURE__*/React.createElement(MediaCardAnalyticsErrorBoundary, {
    dimensions: dimensions,
    onClick: onClick
  }, /*#__PURE__*/React.createElement(Card, props));
};